import { useEntity } from '@backstage/plugin-catalog-react';
import { Container } from '@material-ui/core';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { PostsContainer } from '@drodil/backstage-plugin-qeta-react';

/**
 * SolutionsContent component renders a container for displaying posts related to solutions.
 * @constructor
 */
export const SolutionsContent = () => {
  const { entity } = useEntity();

  return (
    <Container>
      <PostsContainer
        entity={stringifyEntityRef(entity)}
        type="question" // Can be 'question' or 'article' or none
      />
    </Container>
  );
};
